import React from 'react';

type Props = {
    children?: React.ReactNode;
};

export default function ContentWrapper({ children }: Props) {
    return <div className="content-wrapper">{children}</div>;
}
